import React, { createContext, useState, useEffect, useCallback } from 'react';
import { Box } from '@mui/material';

import ClubHouseLogo from '../assets/img/clubhouse_logo.png';
import {
  readSnapshot,
  writeSnapshot,
  clearSnapshot,
} from '../utils/salesSnapshot';

export const AppContext = createContext();

export const AppProvider = ({ children }) => {
  const [enviroment, setEnviroment] = useState('');
  const updateEnviroment = (value) => {
    setEnviroment(value);
  };

  const [isWaitingForUser, setIsWaitingForUser] = useState(false); //To read or not inputs for the keyboard
  const updateIsWaitingForUser = (state) => {
    setIsWaitingForUser(state);
  };
  const [focusOnMainScreen, setFocusOnMainScreen] = useState(true);
  const updateFocusOnMainScreen = (state) => {
    setFocusOnMainScreen(state);
  };

  //Search user
  const [autoSearch, setAutoSearch] = useState(true);
  const [searchByPin, setSearchByPin] = useState(false);
  const [searchByID, setSearchByID] = useState(false);
  const [searchByUsername, setSearchByUsername] = useState(false);
  const [searchByPhonenumber, setSearchByPhonenumber] = useState(false);
  const [searchByFirstname, setSearchByFirstname] = useState(false);
  const [searchByLastname, setSearchByLastname] = useState(false);
  const [searchBySSNID, setSearchBySSNID] = useState(false);

  const updateAutoSearch = (state) => {
    setAutoSearch(state);
  };

  const updateSearchByPin = (state) => {
    setSearchByPin(state);
  };
  const updateSearchByID = (state) => {
    setSearchByID(state);
  };
  const updateSearchByUsername = (state) => {
    setSearchByUsername(state);
  };

  const updateSearchByPhonenumber = (state) => {
    setSearchByPhonenumber(state);
  };

  const updateSearchByFirstname = (state) => {
    setSearchByFirstname(state);
  };
  const updateSearchByLastname = (state) => {
    setSearchByLastname(state);
  };
  const updateSearchBySSNID = (state) => {
    setSearchBySSNID(state);
  };

  //Login into the cashier
  const [isLogin, setIsLogin] = useState(false); //Check if a session is running
  const [session, setSession] = useState(''); //Check if a session is running

  const updateSession = (value) => {
    setSession(value);
  };
  const updateLogin = (login) => {
    setIsLogin(login);
  };
  const modifyLogin = (login) => {
    setTransactions([]);
    setIsLogin(login);
  };
  //End Login into the cashier

  //Login a client
  const [userLogin, setUserLogin] = useState(false);
  const updateUserLogin = (value) => {
    setUserLogin(value);
  };

  const [currentUser, setCurrentUser] = useState(''); //Just the 7pincode
  const updateCurrentUser = (value) => {
    setCurrentUser(value);
  };

  const [currentUserID, setCurrentUserID] = useState(''); //Just the 7pincode
  const updateCurrentUserID = (value) => {
    setCurrentUserID(value);
  };

  const [isFullUser, setIsFullUser] = useState(false);
  const updateIsFullUser = (value) => {
    setIsFullUser(value);
  };

  const [isAnonUser, setIsAnonUser] = useState(false);
  const updateIsAnonUser = (value) => {
    setIsAnonUser(value);
  };

  const [isHybridUser, setIsHybridUser] = useState(false);
  const updateIsHybridUser = (value) => {
    setIsHybridUser(value);
  };

  const [userInfo, setUserInfo] = useState({}); //Full info
  const updateUserInfo = (value) => {
    setUserInfo(value);
  };

  const [isFastUserLogin, setIsFastUserLogin] = useState(false); //Full info
  const updateIsFastUserLogin = (value) => {
    setIsFastUserLogin(value);
  };

  const [userChildren, setUserChildren] = useState([]);
  const updateUserChildren = (value) => {
    setUserChildren(value);
  };

  const [userSiblings, setUserSiblings] = useState([]);
  const updateUserSiblings = (value) => {
    setUserSiblings(value);
  };

  const [userParent, setUserParent] = useState(false);
  const updateUserParent = (value) => {
    setUserParent(value);
  };

  const [parentInfo, setParentInfo] = useState(false);
  const updateParentInfo = (value) => {
    setParentInfo(value);
  };

  //End Login a client

  //Provider Index in Salgs screen
  const [providerIndex, setProviderIndex] = useState(1);
  const updateProviderIndex = (newValue) => {
    setProviderIndex(newValue);
  };
  //End Provider Index in Salgs screen

  //Transactions in Salgs screen
  const [transactions, setTransactions] = useState([]);

  const updateTransactions = (newTransaction) => {
    setTransactions([...transactions, newTransaction]);
  };
  const updateTransactionsArray = (newTransaction) => {
    setTransactions([...transactions, ...newTransaction]);
  };
  const deleteTransactions = (newTransaction) => {
    setTransactions(newTransaction);
  };
  const resetTransactions = (newTransaction) => {
    setTransactions([]);
  };
  const addCancelTransaction = (transactionToDelete, multiplier) => {
    const cancelTransaction = {
      name: 'Avbryt ' + transactionToDelete.name,
      amount: parseInt(transactionToDelete.amount) * multiplier,
      type: 'transaction',
      isCancel: true,
    };

    setTransactions((prevTransactions) => [
      ...prevTransactions,
      cancelTransaction,
    ]);
  };

  useEffect(() => {
    //Loop and bloc
    if (transactions.length > 0) {
      /*
      for (let i = 0; i < transactions.length; i++) {
        if (
          transactions[i].name === "Avbryt Ny Billett - WG" ||
          transactions[i].name === "Cancel New ticket - WG" ||
          transactions[i].name === "Avbryt Ny Billett - OK D." ||
          transactions[i].name === "Cancel New ticket - OK D." ||
          transactions[i].name === "Avbryt Ny Billett - NT" ||
          transactions[i].name === "Cancel New ticket - NT"
        ) {
          setIsBlockProviderWG(true);
          setIsBlockProviderOK(true);
          setIsBlockProviderNT(true);
          return;
        }

        setIsBlockProviderWG(false);
        setIsBlockProviderOK(false);
        setIsBlockProviderNT(false);
      }
        */

      transactions.forEach((transaction) => {
        switch (transaction.name) {
          case 'Ny Billett - WG':
          case 'New ticket - WG':
            setIsBlockProviderWG(true);
            setIsBlockProviderOK(true);
            setIsBlockProviderEBS(true);
            //setIsBlockProviderNT(true);
            break;
          case 'Avbryt Ny Billett - WG':
          case 'Cancel New ticket - WG':
            setIsBlockProviderWG(false);
            setIsBlockProviderOK(false);
            setIsBlockProviderEBS(false);
            //setIsBlockProviderNT(false);
            break;
          case 'Ny Billett - OK D.':
          case 'New ticket - OK D.':
            setIsBlockProviderWG(true);
            setIsBlockProviderOK(true);
            setIsBlockProviderEBS(true);
            //setIsBlockProviderNT(true);
            break;
          case 'Avbryt Ny Billett - OK D.':
          case 'Cancel New ticket - OK D.':
            setIsBlockProviderWG(false);
            setIsBlockProviderOK(false);
            setIsBlockProviderEBS(false);
            //setIsBlockProviderNT(false);
            break;
          case 'Ny Billett - EBS':
          case 'New ticket - EBS':
            setIsBlockProviderWG(true);
            setIsBlockProviderOK(true);
            setIsBlockProviderEBS(true);
            //setIsBlockProviderNT(true);
            break;
          case 'Avbryt Ny Billett - EBS':
          case 'Cancel New ticket - EBS':
            setIsBlockProviderWG(false);
            setIsBlockProviderOK(false);
            setIsBlockProviderEBS(false);
            //setIsBlockProviderNT(false);
            break;
          /*
          case "Ny Billett - NT":
          case "New ticket - NT":
            setIsBlockProviderWG(true);
            setIsBlockProviderOK(true);
            setIsBlockProviderNT(true);
            break;
          case "Avbryt Ny Billett - NT":
          case "Cancel New ticket - NT":
            setIsBlockProviderWG(false);
            setIsBlockProviderOK(false);
            setIsBlockProviderNT(false);
            break;
          */
          default:
            break;
        }
      });
    } else {
      setIsBlockProviderEBS(false);
      setIsBlockProviderWG(false);
      setIsBlockProviderOK(false);
      setIsBlockProviderNT(false);
    }
  }, [transactions]);

  const [ticketsCH, setTicketsCH] = useState([]);

  const addTicketsCH = (newTicket) => {
    setTicketsCH([...ticketsCH, newTicket]);
  };
  const addMultipleTicketsCH = (newTicket) => {
    setTicketsCH([...transactions, ...newTicket]);
  };
  const removeTicketsCH = () => {
    if (ticketsCH.length > 0) {
      setTicketsCH(ticketsCH.slice(1));
    }
  };

  const resetTicketsCH = () => {
    setTicketsCH([]);
  };

  //End Transactions in Salgs screen

  const [operator, setOperator] = useState('');
  const modifyOperator = (operator) => {
    setOperator(operator);
  };

  const [operatorFull, setOperatorFull] = useState('');
  const modifyOperatorFull = (operator) => {
    setOperatorFull(operator);
  };

  const [hall, setHall] = useState('');
  const modifyHall = (hallName) => {
    setHall(hallName);
  };

  const [kioskHall, setKioskHall] = useState('');
  const modifyKioskHall = (hallName) => {
    const formatted = String(hallName).replaceAll('_', ' ');
    if (enviroment === 'stage01' || enviroment === 'stage02') {
      setWGBingoID(247);
      setOKBingoID(246);
      setKioskHall(formatted);
      return;
    }

    switch (formatted) {
      case 'Bingo 1 Askim':
        setWGBingoID(183);
        setOKBingoID(183);
        break;
      case 'Bingo 1 Moss':
        setWGBingoID(125);
        setOKBingoID(125);
        break;
      case 'Bingo 1 Sarpsborg':
        setWGBingoID(172);
        setOKBingoID(172);
        break;
      case 'Bingo 1 Halden':
        setWGBingoID(192);
        setOKBingoID(192);
        break;
      case 'Bingo 1 Veum':
        setWGBingoID(156);
        setOKBingoID(156);
        break;
      case 'Bingo 1 Grimstad':
        setWGBingoID(185);
        setOKBingoID(185);
        break;
      case 'Bingo 1 Demo PROD':
        setWGBingoID(247);
        setOKBingoID(246);
        break;
      case 'Roulingo':
        setWGBingoID(247);
        setOKBingoID(246);
        break;
    }
    setKioskHall(formatted);
  };

  const [showModalEmptyHall, setShowModalEmptyHall] = useState(false);
  const updateShowModalEmptyHall = (state) => {
    setShowModalEmptyHall(state);
  };

  const [operatorInfo, setOperatorInfo] = useState({});
  const modifyOperatorInfo = (info) => {
    setOperatorInfo(info);
  };

  //Size relative block screen
  const [isBlocking, setIsBlocking] = useState(false);

  const BlockingScreen = () => (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: '#15192b',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: 'white',
        fontSize: '24px',
        fontWeight: 'bold',
        zIndex: 100,
        flexDirection: 'column',
      }}
    >
      <Box
        component="img"
        sx={{
          height: '300px',
          width: 'auto',
          paddingTop: 0,
        }}
        alt=""
        src={ClubHouseLogo}
      />

      <p style={{ maxWidth: '400px', textAlign: 'center' }}>
        Skjermoppløsningen er for liten til å kjøre denne appen
      </p>
    </div>
  );

  useEffect(() => {
    const handleResize = () => {
      const { innerWidth, innerHeight } = window;
      setIsBlocking(innerWidth < 1300 || innerHeight < 950);
    };

    window.addEventListener('resize', handleResize);
    const { innerWidth, innerHeight } = window;
    setIsBlocking(innerWidth < 1300 || innerHeight < 950);

    return () => window.removeEventListener('resize', handleResize);
  }, []);
  //End size relative block Screen

  //Block providers (wingames-okbingo)
  const [isBlockProviderOK, setIsBlockProviderOK] = useState(false);
  const [isBlockProviderWG, setIsBlockProviderWG] = useState(false);
  const [isBlockProviderNT, setIsBlockProviderNT] = useState(false);
  const [isBlockProviderEBS, setIsBlockProviderEBS] = useState(false);

  const modifyProvider = (provider, value) => {
    //Block the opposite one
    switch (provider) {
      case 'OK':
        setIsBlockProviderWG(value);
        break;
      case 'WG':
        setIsBlockProviderOK(value);
        break;
      case 'EBS':
        setIsBlockProviderEBS(value);
        break;
      /*
      case "NT":
        setIsBlockProviderNT(value);
        break;
      */
      default:
        break;
    }
  };

  //Multipliers
  const [isMultiplier, setIsMultiplier] = useState(1);
  const [isMultiplier2, setIsMultiplier2] = useState(false);
  const [isMultiplier3, setIsMultiplier3] = useState(false);
  const [isMultiplier4, setIsMultiplier4] = useState(false);
  const [isMultiplier5, setIsMultiplier5] = useState(false);
  const [isMultiplier6, setIsMultiplier6] = useState(false);
  const [isMultiplier7, setIsMultiplier7] = useState(false);
  const [isMultiplier8, setIsMultiplier8] = useState(false);
  const [isMultiplier9, setIsMultiplier9] = useState(false);
  const [isMultiplier10, setIsMultiplier10] = useState(false);

  const updateIsMultiplier = (value) => {
    setIsMultiplier(value);
  };

  const updateIsMultiplier2 = (value) => {
    setIsMultiplier2(value);
  };
  const updateIsMultiplier3 = (value) => {
    setIsMultiplier3(value);
  };
  const updateIsMultiplier4 = (value) => {
    setIsMultiplier4(value);
  };
  const updateIsMultiplier5 = (value) => {
    setIsMultiplier5(value);
  };
  const updateIsMultiplier6 = (value) => {
    setIsMultiplier6(value);
  };
  const updateIsMultiplier7 = (value) => {
    setIsMultiplier7(value);
  };
  const updateIsMultiplier8 = (value) => {
    setIsMultiplier8(value);
  };
  const updateIsMultiplier9 = (value) => {
    setIsMultiplier9(value);
  };
  const updateIsMultiplier10 = (value) => {
    setIsMultiplier10(value);
  };

  //Shortcuts
  const [isShortcut, setIsShortcut] = useState(false);
  const [isShortcut10, setIsShortcut10] = useState(false);
  const [isShortcut20, setIsShortcut20] = useState(false);
  const [isShortcut30, setIsShortcut30] = useState(false);
  const [isShortcut50, setIsShortcut50] = useState(false);
  const [isShortcut100, setIsShortcut100] = useState(false);
  const [isShortcut200, setIsShortcut200] = useState(false);

  const updateIsShortcut = (value) => {
    setIsShortcut(value);
  };

  const updateIsShortcut10 = (value) => {
    setIsShortcut10(value);
  };
  const updateIsShortcut20 = (value) => {
    setIsShortcut20(value);
  };
  const updateIsShortcut30 = (value) => {
    setIsShortcut30(value);
  };
  const updateIsShortcut50 = (value) => {
    setIsShortcut50(value);
  };
  const updateIsShortcut100 = (value) => {
    setIsShortcut100(value);
  };
  const updateIsShortcut200 = (value) => {
    setIsShortcut200(value);
  };

  //Amounts
  const [total, setTotal] = useState(() => {
    return transactions.reduce((acc, obj) => acc + parseInt(obj.amount), 0);
  });

  const [cardID, setCardID] = useState('');
  const updateCardID = (value) => {
    setCardID(value);
  };

  const [payCard, setPayCard] = useState(0);
  const [payCardTemp, setPayCardTemp] = useState(0);
  const [payCash, setPayCash] = useState(0);
  const [payCashTemp, setPayCashTemp] = useState(0);
  const [paySpillerkonto, setPaySpillerkonto] = useState(0);
  const [paySpillerkontoTemp, setPaySpillerkontoTemp] = useState(0);

  const [change, setChange] = useState(0);
  const [withdraw, setWithdraw] = useState(0);
  const updateTotal = (value) => {
    setTotal(value);
  };
  const updatePayCard = (value) => {
    setPayCard(value);
  };
  const updatePayCash = (value) => {
    setPayCash(value);
  };
  const updatePayCardTemp = (value) => {
    setPayCardTemp(value);
  };
  const updatePayCashTemp = (value) => {
    setPayCashTemp(value);
  };
  const updatePaySpillerkonto = (value) => {
    setPaySpillerkonto(value);
  };
  const updatePaySpillerkontoTemp = (value) => {
    setPaySpillerkontoTemp(value);
  };

  const updateChange = (value) => {
    setChange(value);
  };
  const updateWithdraw = (value) => {
    setWithdraw(value);
  };

  useEffect(() => {
    if (transactions.length === 0) {
      setIsPaymentOpen(false);
    }
    setTotal(
      transactions.reduce((acc, obj) => {
        if (obj.type === 'transaction') {
          return acc + parseInt(obj.amount);
        }
        return acc;
      }, 0)
    );

    setWithdraw(
      transactions.reduce((acc, obj) => {
        if (obj.type === 'withdraw') {
          return acc + parseInt(obj.amount);
        }
        return acc;
      }, 0)
    );

    setPayCard(
      transactions.reduce((acc, obj) => {
        if (obj.type === 'paymentCard') {
          return acc + parseInt(obj.amount);
        }
        return acc;
      }, 0)
    );

    setPaySpillerkonto(
      transactions.reduce((acc, obj) => {
        if (obj.type === 'paymentSpillerkonto') {
          return acc + parseInt(obj.amount);
        }
        return acc;
      }, 0)
    );

    setPayCash(
      transactions.reduce((acc, obj) => {
        if (obj.type === 'paymentCash') {
          return acc + parseInt(obj.amount);
        }
        return acc;
      }, 0)
    );
  }, [transactions]);

  useEffect(() => {
    if (
      total -
        (payCard + payCardTemp) -
        (payCash + payCashTemp) -
        (paySpillerkonto + paySpillerkontoTemp) -
        withdraw >
      0
    ) {
      setChange(0);
      return;
    }
    setChange(
      (total -
        (payCard + payCardTemp) -
        (payCash + payCashTemp) -
        (paySpillerkonto + paySpillerkontoTemp) -
        withdraw) *
        -1
    );
  }, [payCard, payCardTemp]);

  useEffect(() => {
    if (
      total -
        (payCard + payCardTemp) -
        (payCash + payCashTemp) -
        (paySpillerkonto + paySpillerkontoTemp) -
        withdraw >
      0
    ) {
      setChange(0);
      return;
    }
    setChange(
      (total -
        (payCard + payCardTemp) -
        (payCash + payCashTemp) -
        (paySpillerkonto + paySpillerkontoTemp) -
        withdraw) *
        -1
    );
  }, [payCash, payCashTemp]);

  useEffect(() => {
    if (
      total -
        (payCard + payCardTemp) -
        (payCash + payCashTemp) -
        (paySpillerkonto + paySpillerkontoTemp) -
        withdraw >
      0
    ) {
      setChange(0);
      return;
    }
    setChange(
      (total -
        (payCard + payCardTemp) -
        (payCash + payCashTemp) -
        (paySpillerkonto + paySpillerkontoTemp) -
        withdraw) *
        -1
    );
  }, [paySpillerkonto, paySpillerkontoTemp]);

  useEffect(() => {
    if (
      total -
        (payCard + payCardTemp) -
        (payCash + payCashTemp) -
        (paySpillerkonto + paySpillerkontoTemp) -
        withdraw >
      0
    ) {
      setChange(0);
      return;
    }
    setChange(
      (total -
        (payCard + payCardTemp) -
        (payCash + payCashTemp) -
        (paySpillerkonto + paySpillerkontoTemp) -
        withdraw) *
        -1
    );
  }, [total]);

  const [showSignature, setShowSignature] = useState(false);
  const updateShowSignature = (state) => {
    setShowSignature(state);
  };

  const [isSigned, setIsSigned] = useState(false);
  const updateIsSigned = (state) => {
    setIsSigned(state);
  };

  useEffect(() => {
    if (
      total - (payCard + payCardTemp) - (payCash + payCashTemp) - withdraw >
      0
    ) {
      setChange(0);
      return;
    }
    setChange(
      (total - (payCard + payCardTemp) - (payCash + payCashTemp) - withdraw) *
        -1
    );
  }, [withdraw]);

  //Screens
  const [isCard, setIsCard] = useState(false);
  const [isCash, setIsCash] = useState(false);

  const updateIsCard = (state) => {
    setIsCard(state);
  };
  const updateIsCash = (state) => {
    setIsCash(state);
  };

  const [isSellerOpen, setIsSellerOpen] = useState(false);
  const updateIsSellerOpen = (state) => {
    setIsSellerOpen(state);
  };

  const [isPapirOpen, setIsPapirOpen] = useState(false);
  const updateIsPapirOpen = (state) => {
    setIsPapirOpen(state);
  };

  const [isPapirKingoOpen, setIsPapirKingoOpen] = useState(false);
  const updateIsPapirKingoOpen = (state) => {
    setIsPapirKingoOpen(state);
  };

  const [isPapirXtippOpen, setIsPapirXtippOpen] = useState(false);
  const updateIsPapirXtippOpen = (state) => {
    setIsPapirXtippOpen(state);
  };

  const [isFlaxOpen, setIsFlaxOpen] = useState(false);
  const updateIsFlaxOpen = (state) => {
    setIsFlaxOpen(state);
  };

  const [isPaymentOpen, setIsPaymentOpen] = useState(false);
  const updateIsPaymentOpen = (state) => {
    setIsPaymentOpen(state);
  };

  const [paymentType, setPaymentType] = useState(false);
  const updatePaymentType = (value) => {
    setPaymentType(value);
  };

  const [isOcrOpen, setIsOcrOpen] = useState(false);
  const updateIsOcrOpen = (state) => {
    setIsOcrOpen(state);
  };

  const [vendorInfo, setVendorInfo] = useState('');
  const [sellType, setSellType] = useState(0);

  const updateVendorInfo = (info) => {
    setVendorInfo(info);
  };

  const updateSellType = (type) => {
    setSellType(type);
  };

  const [print, setPrint] = useState(false);
  const updatePrint = (state) => {
    setPrint(state);
  };

  const [printer, setPrinter] = useState(true);
  const updatePrinter = (state) => {
    setPrinter(state);
  };

  //Modal for the card payment
  const [showCard, setShowCard] = useState(false);

  const updateShowCard = useCallback((state) => {
    setShowCard(state);
  }, []);

  const [showCardToCash, setShowCardToCash] = useState(false);
  const updateShowCardToCash = (state) => {
    setShowCardToCash(state);
  };

  const [isSingleTransaction, setIsSingleTransaction] = useState(false);
  const updateIsSingleTransaction = (state) => {
    setIsSingleTransaction(state);
  };

  const [showSpillerkonto, setShowSpillerkonto] = useState(false);

  const updateShowSpillerkonto = (state) => {
    setShowSpillerkonto(state);
  };

  const [showSpillerkontoPayment, setShowSpillerkontoPayment] = useState(false);

  const updateShowSpillerkontoPayment = (state) => {
    setShowSpillerkontoPayment(state);
  };

  const [receiptToPrint, setReceiptToPrint] = useState(false);
  const updateReceiptToPrint = (state) => {
    setReceiptToPrint(state);
  };

  const [papirPrize, setPapirPrize] = useState('');
  const updatePapirPrize = (value) => {
    setPapirPrize(value);
  };

  const logoutUser = () => {
    setIsEditingAfterExpiry(false);
    setLockUserInfo(false);
    setLastDataBingoTicket(false);
    setPapirPrize('');
    setUserInfoBlocked(false);
    setIsIdentityConfirmed(false);
    setIsLoginFromNfc(false);
    setShowModalUserNeedManualCheck(false);
    setSignatureInfo(false);
    setImageVerificationSignatureTemp(false);
    setImageVerificationTemp(false);
    setIsNeedSignature(false);
    setIsNeedConfirmation(false);
    updateUserImageInfo(false);
    updateShowModalDifferentParent(false);
    updateShowModalDifferentParentOK(false);
    updateShowModalDifferentParentWG(false);
    updateAdoptedTicket({});
    updateScannedTicket({});
    updateShowUserInfoSiblingOK(false);
    updateShowUserInfoSibling(false);
    updateShowUserInfoOK(false);
    updateShowUserInfoWG(false);
    updateIsWaitingForExternalProviderInfo(false);
    updateShowUserInfo(false);
    updateUserToSearch('');
    updateUserResults([]);
    updateReceiptToPrint(false);
    updatePrint(false);
    resetTransactions();
    updateIsCard(false);
    updateIsCash(false);
    updateTotal(0);
    updatePayCard(0);
    updatePayCash(0);
    updatePaySpillerkonto(0);
    updateChange(0);
    updateWithdraw(0);
    updateCurrentUser('');
    updateUserLogin(false);
    updatePaymentType('');
    updateIsPaymentOpen(false);
    updateIsSellerOpen(false);
    updateIsPapirOpen(false);
    updateIsPapirKingoOpen(false);
    updateIsPapirXtippOpen(false);
    updateIsFlaxOpen(false);
    updateCurrentUser('');
    updateUserLogin(false);
    updateUserInfo({});
    updateIsFastUserLogin(false);
    updateIsAnonUser(false);
    updateIsHybridUser(false);
    updateIsFullUser(false);
    updateUserParent(false);
    updateParentInfo(false);
    updateUserChildren([]);
    updateUserSiblings([]);
    resetTicketsCH();
    setTicketsEBS([]);
    setCurrentTicketEBS(false);
    setTicketsWG([]);
    setCurrentTicketWG(false);
    setUserLimits({});
    setIsVerificationNeeded(false);
    setIsLimitSurpassed(false);
    setIsDailyLimitSurpassed(false);
    setIsMonthlyLimitSurpassed(false);
    updateCurrentTicketOK(false);
    updateCurrentTicketTempOK(false);
    updateTicketsOK([]);
    setTicketsTempOK([]);
    updateCurrentTicketWG(false);
    updateTicketsWG([]);
    setTicketsTempWG([]);
    updateDisableSellForUser(false);

    // The sale is over: nothing left to recover
    clearSnapshot();
    setPendingSnapshot(null);

    setTimeout(() => {
      setIsLoadingScreen(false);
    }, 500);
  };

  const [showSpecialGames, setShowSpecialGames] = useState(false);

  const updateShowSpecialGames = (state) => {
    setShowSpecialGames(state);
  };

  const [isFullUserRegistration, setIsFullUserRegistration] = useState(false);
  const updateIsFullUserRegistration = (state) => {
    setIsFullUserRegistration(state);
  };
  const [isFullUserEditing, setIsFullUserEditing] = useState(false);
  const updateIsFullUserEditing = (state) => {
    setIsFullUserEditing(state);
  };

  const [isHybridUserRegistration, setIsHybridUserRegistration] =
    useState(false);
  const updateIsHybridUserRegistration = (state) => {
    setIsHybridUserRegistration(state);
  };
  const [isHybridUserEditing, setIsHybridUserEditing] = useState(false);
  const updateIsHybridUserEditing = (state) => {
    setIsHybridUserEditing(state);
  };

  const [isAnonUserRegistration, setIsAnonUserRegistration] = useState(false);
  const updateIsAnonUserRegistration = (state) => {
    setIsAnonUserRegistration(state);
  };

  const [isTerminalBusy, setIsTerminalBusy] = useState(false);
  const updateIsTerminalBusy = (state) => {
    setIsTerminalBusy(state);
  };

  const [isCashoutPending, setIsCashoutPending] = useState(false);
  const updateIsCashoutPending = (state) => {
    setIsCashoutPending(state);
  };

  const [refreshUser, setRefreshUser] = useState(false);
  const updateRefreshUser = (state) => {
    setRefreshUser(state);
  };

  const [gameID, setGameID] = useState('');
  const updateGameID = (value) => {
    setGameID(value);
  };
  const [specialGameInfo, setSpecialGameInfo] = useState(false);
  const updateSpecialGameInfo = (value) => {
    setSpecialGameInfo(value);
  };

  const [isReportEnabled, setIsReportEnabled] = useState(true);
  const updateIsReportEnabled = (state) => {
    setIsReportEnabled(state);
  };

  const [isShiftOpen, setIsShiftOpen] = useState(true);
  const updateIsShiftOpen = (state) => {
    setIsShiftOpen(state);
  };

  const [isFirstShiftOfTheDay, setIsFirstShiftOfTheDay] = useState(false);
  const updateIsFirstShiftOfTheDay = (state) => {
    setIsFirstShiftOfTheDay(state);
  };

  // What the previous operator counted and signed for; null when no shift was closed with a count
  const [previousShiftClose, setPreviousShiftClose] = useState(null);
  const updatePreviousShiftClose = (state) => {
    setPreviousShiftClose(state);
  };

  const [closeShiftNumbers, setCloseShiftNumbers] = useState(false);
  const updateCloseShiftNumbers = (state) => {
    setCloseShiftNumbers(state);
  };

  const [ticketPictureWG, setTicketPictureWG] = useState('');
  const updateTicketPictureWG = (value) => {
    setTicketPictureWG(value);
  };
  const [ticketPictureOK, setTicketPictureOK] = useState('');
  const updateTicketPictureOK = (value) => {
    setTicketPictureOK(value);
  };

  const [ticketPictureNT, setTicketPictureNT] = useState('');
  const updateTicketPictureNT = (value) => {
    setTicketPictureNT(value);
  };

  const [openSessionTerminal, setOpenSessionTerminal] = useState(false);
  const updateOpenSessionTerminal = (state) => {
    setOpenSessionTerminal(state);
  };

  const [showModalStartShift, setShowModalStartShift] = useState(false);
  const updateShowModalStartShift = (state) => {
    setShowModalStartShift(state);
  };

  const [showModalEndShift, setShowModalEndShift] = useState(false);
  const updateShowModalEndShift = (state) => {
    setShowModalEndShift(state);
  };
  const [isDailyReportCompleted, setIsDailyReportCompleted] = useState(false);
  const updateIsDailyReportCompleted = (state) => {
    setIsDailyReportCompleted(state);
  };
  const [isCardReportCompleted, setIsCardReportCompleted] = useState(false);
  const updateIsCardReportCompleted = (state) => {
    setIsCardReportCompleted(state);
  };

  const [isWGReportCompleted, setIsWGReportCompleted] = useState(false);
  const updateIsWGReportCompleted = (state) => {
    setIsWGReportCompleted(state);
  };

  const [showUserInfo, setShowUserInfo] = useState(false);
  const updateShowUserInfo = (state) => {
    setShowUserInfo(state);
  };

  const [showUserInfoOK, setShowUserInfoOK] = useState(false);
  const updateShowUserInfoOK = (state) => {
    setShowUserInfoOK(state);
  };

  const [showUserInfoWG, setShowUserInfoWG] = useState(false);
  const updateShowUserInfoWG = (state) => {
    setShowUserInfoWG(state);
  };

  const [
    isWaitingForExternalProviderInfo,
    setIsWaitingForExternalProviderInfo,
  ] = useState(false);
  const updateIsWaitingForExternalProviderInfo = (state) => {
    setIsWaitingForExternalProviderInfo(state);
  };

  const [allUsers, setAllUsers] = useState([]);
  const updateAllUsers = (value) => {
    setAllUsers(value);
  };

  const [showKiosk, setShowKiosk] = useState(false);
  const updateShowKiosk = (state) => {
    setShowKiosk(state);
  };

  const [showModalUserFound, setShowModalUserFound] = useState(false);
  const updateShowModalUserFound = (state) => {
    setShowModalUserFound(state);
  };
  const [showModalUserNotFound, setShowModalUserNotFound] = useState(false);
  const updateShowModalUserNotFound = (state) => {
    setShowModalUserNotFound(state);
  };

  const [userToSearch, setUserToSearch] = useState('');
  const updateUserToSearch = (value) => {
    setUserToSearch(value);
  };
  const [usersResults, setUsersResults] = useState([]);
  const updateUserResults = (value) => {
    setUsersResults(value);
  };

  const [ticketsEBS, setTicketsEBS] = useState([]);
  const updateTicketsEBS = (value) => {
    setTicketsEBS(value);
  };
  const [currentTicketEBS, setCurrentTicketEBS] = useState(false);
  const updateCurrentTicketEBS = (value) => {
    setCurrentTicketEBS(value);
  };

  const [ticketsWG, setTicketsWG] = useState([]);
  const updateTicketsWG = (value) => {
    setTicketsWG(value);
  };
  const [currentTicketWG, setCurrentTicketWG] = useState(false);
  const updateCurrentTicketWG = (value) => {
    setCurrentTicketWG(value);
  };

  const [ticketsOK, setTicketsOK] = useState([]);
  const updateTicketsOK = (value) => {
    setTicketsOK(value);
  };

  const [ticketsTempOK, setTicketsTempOK] = useState([]);

  const updateTicketsTempOK = (ticketData) => {
    setTicketsTempOK((prevData) => [...prevData, ticketData]);
  };

  const [ticketsTempWG, setTicketsTempWG] = useState([]);
  const updateTicketsTempWG = (ticketData) => {
    setTicketsTempWG((prevData) => [...prevData, ticketData]);
  };

  const updateTicketsOKWithNewSaldo = (ticketData) => {
    setTicketsOK((prevData) =>
      prevData.map((item) =>
        item.okID === ticketData.ticketNumber
          ? {
              ...item,
              amount: ticketData.newSaldo,
              errorDescription: ticketData.errorDescription,
              errorNumber: ticketData.errorNumber,
            }
          : item
      )
    );
  };

  const [currentTicketOK, setCurrentTicketOK] = useState(false);
  const updateCurrentTicketOK = (value) => {
    setCurrentTicketOK(value);
  };

  const [currentTicketTempOK, setCurrentTicketTempOK] = useState(false);
  const updateCurrentTicketTempOK = (value) => {
    setCurrentTicketTempOK(value);
  };

  const [favUsers, setFavUsers] = useState([]);
  const updateFavUsers = (value) => {
    setFavUsers(value);
  };

  const [showModalEditUserLimits, setShowModalEditUserLimits] = useState(false);
  const updateShowModalEditUserLimits = (state) => {
    setShowModalEditUserLimits(state);
  };

  const [showIsLimitSurpassed, setShowIsLimitSurpassed] = useState(false);
  const updateShowIsLimitSurpassed = (state) => {
    setShowIsLimitSurpassed(state);
  };

  const [showIsLimitSurpassedTransaction, setShowIsLimitSurpassedTransaction] =
    useState(false);
  const updateShowIsLimitSurpassedTransaction = (state) => {
    setShowIsLimitSurpassedTransaction(state);
  };

  const [isLimitSurpassed, setIsLimitSurpassed] = useState(false);
  const updateIsLimitSurpassed = (state) => {
    setIsLimitSurpassed(state);
  };

  const [isDailyLimitSurpassed, setIsDailyLimitSurpassed] = useState(false);
  const updateIsDailyLimitSurpassed = (state) => {
    setIsDailyLimitSurpassed(state);
  };

  const [isMonthlyLimitSurpassed, setIsMonthlyLimitSurpassed] = useState(false);
  const updateIsMonthlyLimitSurpassed = (state) => {
    setIsMonthlyLimitSurpassed(state);
  };

  const [isVerificationNeeded, setIsVerificationNeeded] = useState(false);
  const updateIsVerificationNeeded = (state) => {
    setIsVerificationNeeded(state);
  };

  const [showModalIsVerificationNeeded, setShowModalIsVerificationNeeded] =
    useState(false);
  const updateShowModalIsVerificationNeeded = (state) => {
    setShowModalIsVerificationNeeded(state);
  };

  const [userLimits, setUserLimits] = useState({});
  const updateUserLimits = (value) => {
    setUserLimits(value);
  };

  const [maxAllowed, setMaxAllowed] = useState(0);
  const updateMaxAllowed = (value) => {
    setMaxAllowed(value);
  };

  const [showModalDifferentParent, setShowModalDifferentParent] =
    useState(false);
  const updateShowModalDifferentParent = (state) => {
    setShowModalDifferentParent(state);
  };

  const [showModalDifferentParentOK, setShowModalDifferentParentOK] =
    useState(false);
  const updateShowModalDifferentParentOK = (state) => {
    setShowModalDifferentParentOK(state);
  };

  const [showModalDifferentParentWG, setShowModalDifferentParentWG] =
    useState(false);
  const updateShowModalDifferentParentWG = (state) => {
    setShowModalDifferentParentWG(state);
  };

  const [adoptedTicket, setAdoptedTicket] = useState({});
  const updateAdoptedTicket = (state) => {
    setAdoptedTicket(state);
  };

  const [showUserInfoSibling, setShowUserInfoSibling] = useState(false);
  const updateShowUserInfoSibling = (state) => {
    setShowUserInfoSibling(state);
  };

  const [showUserInfoSiblingOK, setShowUserInfoSiblingOK] = useState(false);
  const updateShowUserInfoSiblingOK = (state) => {
    setShowUserInfoSiblingOK(state);
  };

  const [scannedTicket, setScannedTicket] = useState({});
  const updateScannedTicket = (state) => {
    setScannedTicket(state);
  };

  const [isPictureVerificationNeeded, setIsPictureVerificationNeeded] =
    useState(false);
  const updateIsPictureVerificationNeeded = (state) => {
    setIsPictureVerificationNeeded(state);
  };

  const [
    showModalPictureVerificationWarning,
    setShowModalPictureVerificationWarning,
  ] = useState(false);
  const updateShowModalPictureVerificationWarning = (state) => {
    setShowModalPictureVerificationWarning(state);
  };

  const [showModalPictureVerification, setShowModalPictureVerification] =
    useState(false);
  const updateShowModalPictureVerification = (state) => {
    setShowModalPictureVerification(state);
  };

  const [
    showModalPictureVerificationPreRegister,
    setShowModalPictureVerificationPreRegister,
  ] = useState(false);
  const updateShowModalPictureVerificationPreRegister = (state) => {
    setShowModalPictureVerificationPreRegister(state);
  };

  const [userImageInfo, setUserImageInfo] = useState(false);
  const updateUserImageInfo = (state) => {
    setUserImageInfo(state);
  };

  const [showModalProfileImage, setShowModalProfileImage] = useState(false);
  const updateShowModalProfileImage = (state) => {
    setShowModalProfileImage(state);
  };

  const [imageVerificationTemp, setImageVerificationTemp] = useState(false);
  const updateImageVerificationTemp = (state) => {
    setImageVerificationTemp(state);
  };

  const [imageVerificationSignatureTemp, setImageVerificationSignatureTemp] =
    useState(false);
  const updateImageVerificationSignatureTemp = (state) => {
    setImageVerificationSignatureTemp(state);
  };

  const [isDisconnected, setIsDisconnected] = useState(false);
  const updateIsDisconnected = (state) => {
    setIsDisconnected(state);
  };
  const [isReconnected, setIsReconnected] = useState(false);
  const updateIsReconnected = (state) => {
    setIsReconnected(state);
  };

  const [isOKBingoEnabled, setIsOKBingoEnabled] = useState(false);
  const updateIsOKBingoEnabled = (state) => {
    setIsOKBingoEnabled(state);
  };

  const [isWGEnabled, setIsWGEnabled] = useState(false);
  const updateIsWGEnabled = (state) => {
    setIsWGEnabled(state);
  };

  const [OKBingoID, setOKBingoID] = useState(false);
  useEffect(() => {}, [OKBingoID]);
  const updateOKBingoID = (value) => {
    setOKBingoID(value);
  };

  const [WGBingoID, setWGBingoID] = useState(false);
  useEffect(() => {}, [WGBingoID]);
  const updateWGBingoID = (value) => {
    setWGBingoID(value);
  };

  const [signatureInfo, setSignatureInfo] = useState(false);
  const updateSignatureInfo = (state) => {
    setSignatureInfo(state);
  };

  const [showModalSignatureStep1, setShowModalSignatureStep1] = useState(false);
  const updateShowModalSignatureStep1 = (state) => {
    setShowModalSignatureStep1(state);
  };
  const [showModalSignatureStep2, setShowModalSignatureStep2] = useState(false);
  const updateShowModalSignatureStep2 = (state) => {
    setShowModalSignatureStep2(state);
  };

  const [isLoadingScreen, setIsLoadingScreen] = useState(false);
  const updateIsLoadingScreen = (state) => {
    setIsLoadingScreen(state);
  };

  const [signatureTemp, setSignatureTemp] = useState(false);
  const updateSignatureTemp = (state) => {
    setSignatureTemp(state);
  };

  const [isNeedSignature, setIsNeedSignature] = useState('');
  const updateIsNeedSignature = (value) => {
    setIsNeedSignature(value);
  };

  const [isNeedConfirmation, setIsNeedConfirmation] = useState(false);
  const updateIsNeedConfirmation = (value) => {
    setIsNeedConfirmation(value);
  };

  const [reactivateNeedSignatureModal, setReactivateNeedSignatureModal] =
    useState(false);
  const updateReactivateNeedSignatureModal = (state) => {
    setReactivateNeedSignatureModal(state);
  };

  const [isWaitingForCancelOK, setIsWaitingForCancelOK] = useState(false);
  const updateIsWaitingForCancelOK = (state) => {
    setIsWaitingForCancelOK(state);
  };
  const [isNTEnabled, setIsNTEnabled] = useState(false);
  const updateIsNTEnabled = (state) => {
    setIsNTEnabled(state);
  };
  const [isKioskEnabled, setIsKioskEnabled] = useState(false);
  const updateIsKioskEnabled = (state) => {
    setIsKioskEnabled(state);
  };

  const [isSignaturesStored, setIsSignaturesStored] = useState(false);
  const updateIsSignaturesStored = (state) => {
    setIsSignaturesStored(state);
  };

  const [showModalSignaturePostponed, setShowModalSignaturePostponed] =
    useState(false);
  const updateShowModalSignaturePostponed = (state) => {
    setShowModalSignaturePostponed(state);
  };

  const [isPostponedID, setIsPostponedID] = useState(false);
  const updateIsPostponedID = (value) => {
    setIsPostponedID(value);
  };

  const [showWaitingForScan, setShowWaitingForScan] = useState(false);
  const updateShowWaitingForScan = (state) => {
    setShowWaitingForScan(state);
  };

  const [showWaitingForScanNfc, setShowWaitingForScanNfc] = useState(false);
  const updateShowWaitingForScanNfc = (state) => {
    setShowWaitingForScanNfc(state);
  };

  const [showPreRegisterForm, setShowPreRegisterForm] = useState(false);
  const updateShowPreRegisterForm = (state) => {
    setShowPreRegisterForm(state);
  };

  const [showPreRegisterHybridForm, setShowPreRegisterHybridForm] =
    useState(false);
  const updateShowPreRegisterHybridForm = (state) => {
    setShowPreRegisterHybridForm(state);
  };

  const [showBankIDForm, setShowBankIDForm] = useState(false);
  const updateShowBankIDForm = (state) => {
    setShowBankIDForm(state);
  };

  const [showModalPEP, setShowModalPEP] = useState(false);
  const updateShowModalPEP = (state) => {
    setShowModalPEP(state);
  };

  const [showModalWaitingForPEP, setShowModalWaitingForPEP] = useState(false);
  const updateShowModalWaitingForPEP = (state) => {
    setShowModalWaitingForPEP(state);
  };

  const [showModalWaitingForTerms, setShowModalWaitingForTerms] =
    useState(false);
  const updateShowModalWaitingForTerms = (state) => {
    setShowModalWaitingForTerms(state);
  };

  const [
    showModalWaitingForCommunication,
    setShowModalWaitingForCommunication,
  ] = useState(false);
  const updateShowModalWaitingForCommunication = (state) => {
    setShowModalWaitingForCommunication(state);
  };

  const [showModalWaitingForNewPincode, setShowModalWaitingForNewPincode] =
    useState(false);
  const updateShowModalWaitingForNewPincode = (state) => {
    setShowModalWaitingForNewPincode(state);
  };

  const [userRegisterCommunication, setUserRegisterCommunication] =
    useState(false);
  const updateUserRegisterCommunication = (state) => {
    setUserRegisterCommunication(state);
  };

  const [userRegisterTerms, setUserRegisterTerms] = useState(false);
  const updateUserRegisterTerms = (state) => {
    setUserRegisterTerms(state);
  };

  const [userRegisterPEP, setUserRegisterPEP] = useState(false);
  const updateUserRegisterPEP = (state) => {
    setUserRegisterPEP(state);
  };

  const [userRegisterOptionsPEP, setUserRegisterOptionsPEP] = useState(false);
  const updateUserRegisterOptionsPEP = (update) => {
    setUserRegisterOptionsPEP((prevState) => ({
      ...prevState, // Spread the current state
      ...update, // Spread the new updates
    }));
  };

  const [showModalHybridMustBeUser, setShowModalHybridMustBeUser] =
    useState(false);
  const updateShowModalHybridMustBeUser = (state) => {
    setShowModalHybridMustBeUser(state);
  };

  const [showModalUserNeedManualCheck, setShowModalUserNeedManualCheck] =
    useState(false);
  const updateShowModalUserNeedManualCheck = (state) => {
    setShowModalUserNeedManualCheck(state);
  };

  const [showModalUserIsBanned, setShowModalUserIsBanned] = useState(false);
  const updateShowModalUserIsBanned = (state) => {
    setShowModalUserIsBanned(state);
  };

  const [showModalBanUser, setShowModalBanUser] = useState(false);
  const updateShowModalBanUser = (state) => {
    setShowModalBanUser(state);
  };

  const [showModalWaitingForRisky, setShowModalWaitingForRisky] =
    useState(false);
  const updateShowModalWaitingForRisky = (state) => {
    setShowModalWaitingForRisky(state);
  };

  const [showModalConfirmIdentity, setShowModalConfirmIdentity] =
    useState(false);
  const updateShowModalConfirmIdentity = (state) => {
    setShowModalConfirmIdentity(state);
  };

  const [isLoginFromNfc, setIsLoginFromNfc] = useState(false);
  const updateIsLoginFromNfc = (state) => {
    setIsLoginFromNfc(state);
  };

  const [bingoID, setBingoID] = useState('');
  const updateBingoID = (value) => {
    setBingoID(value);
  };

  const [isIdentityConfirmed, setIsIdentityConfirmed] = useState(false);
  const updateIsIdentityConfirmed = (state) => {
    setIsIdentityConfirmed(state);
  };

  const [isEnabledBankID, setIsEnabledBankID] = useState(false);
  const updateIsEnabledBankID = (state) => {
    setIsEnabledBankID(state);
  };

  const [isMainGameBlocked, setIsMainGameBlocked] = useState(false);
  const updateIsMainGameBlocked = (state) => {
    setIsMainGameBlocked(state);
  };
  const [isDataBingoBlocked, setIsDataBingoBlocked] = useState(false);
  const updateIsDataBingoBlocked = (state) => {
    setIsDataBingoBlocked(state);
  };

  const [showModalSellBlocked, setShowModalSellBlocked] = useState(false);
  const updateShowModalSellBlocked = (state) => {
    setShowModalSellBlocked(state);
  };

  const [userInfoBlocked, setUserInfoBlocked] = useState(false);
  const updateUserInfoBlocked = (state) => {
    setUserInfoBlocked(state);
  };

  const [showModalUserLimitStatus, setShowModalUserLimitStatus] =
    useState(false);
  const updateShowModalUserLimitStatus = (state) => {
    setShowModalUserLimitStatus(state);
  };

  const [isSystemLockEnabled, setIsSystemLockEnabled] = useState(false);
  const updateIsSystemLockEnabled = (state) => {
    setIsSystemLockEnabled(state);
  };

  const [showModalForbiddenUserAccess, setShowModalForbiddenUserAccess] =
    useState(false);
  const updateShowModalForbiddenUserAccess = (state) => {
    setShowModalForbiddenUserAccess(state);
  };

  const [showModalUserHasPasswordBlock, setShowModalUserHasPasswordBlock] =
    useState(false);
  const updateShowModalUserHasPasswordBlock = (state) => {
    setShowModalUserHasPasswordBlock(state);
  };

  const [disableSellForUser, setDisableSellForUser] = useState(false);
  const updateDisableSellForUser = (state) => {
    setDisableSellForUser(state);
  };

  const [isAdmin, setIsAdmin] = useState(false);
  const updateIsAdmin = (state) => {
    setIsAdmin(state);
  };

  const [isPapirEnabled, setIsPapirEnabled] = useState(false);
  const updateIsPapirEnabled = (state) => {
    setIsPapirEnabled(state);
  };

  const [isPapirKingoEnabled, setIsPapirKingoEnabled] = useState(false);
  const updateIsPapirKingoEnabled = (state) => {
    setIsPapirKingoEnabled(state);
  };

  const [isPapirXtippEnabled, setIsPapirXtippEnabled] = useState(false);
  const updateIsPapirXtippEnabled = (state) => {
    setIsPapirXtippEnabled(state);
  };

  const [isFlaxEnabled, setIsFlaxEnabled] = useState(false);
  const updateIsFlaxEnabled = (state) => {
    setIsFlaxEnabled(state);
  };

  const [showModalPapirTicketNotSold, setShowModalPapirTicketNotSold] =
    useState(false);
  const updateShowModalPapirTicketNotSold = (state) => {
    setShowModalPapirTicketNotSold(state);
  };
  const [showModalPapirTicketAlreadySold, setShowModalPapirTicketAlreadySold] =
    useState(false);
  const updateShowModalPapirTicketAlreadySold = (state) => {
    setShowModalPapirTicketAlreadySold(state);
  };
  const [showModalPapirGameNotFinished, setShowModalPapirGameNotFinished] =
    useState(false);
  const updateShowModalPapirGameNotFinished = (state) => {
    setShowModalPapirGameNotFinished(state);
  };

  const [
    showModalPapirGameFinishedWithPrize,
    setShowModalPapirGameFinishedWithPrize,
  ] = useState(false);
  const updateShowModalPapirGameFinishedWithPrize = (state) => {
    setShowModalPapirGameFinishedWithPrize(state);
  };
  const [
    showModalPapirGameFinishedWithoutPrize,
    setShowModalPapirGameFinishedWithoutPrize,
  ] = useState(false);
  const updateShowModalPapirGameFinishedWithoutPrize = (state) => {
    setShowModalPapirGameFinishedWithoutPrize(state);
  };

  const [showModalPapirCheckCard, setShowModalPapirCheckCard] = useState(false);
  const updateShowModalPapirCheckCard = (state) => {
    setShowModalPapirCheckCard(state);
  };

  const [showModalPapirGameBatchResult, setShowModalPapirGameBatchResult] =
    useState(false);
  const updateShowModalPapirGameBatchResult = (state) => {
    setShowModalPapirGameBatchResult(state);
  };

  const [showModalPapirTicketNotValid, setShowModalPapirTicketNotValid] =
    useState(false);
  const updateShowModalPapirTicketNotValid = (state) => {
    setShowModalPapirTicketNotValid(state);
  };

  const [papirScannedInfo, setPapirScannedInfo] = useState(false);
  const updatePapirScannedInfo = (state) => {
    setPapirScannedInfo(state);
  };

  const [papirCardInfo, setPapirCardInfo] = useState(false);
  const updatePapirCardInfo = (state) => {
    setPapirCardInfo(state);
  };

  const [maximumAnonPrizeAllowed, setMaximumAnonPrizeAllowed] = useState(2000);
  const updateMaximumAnonPrizeAllowed = (amount) => {
    setMaximumAnonPrizeAllowed(amount);
  };

  const [showModalRefund, setShowModalRefund] = useState(false);
  const updateShowModalRefund = (state) => {
    setShowModalRefund(state);
  };

  // Entry point for every hand-entered cash movement, refusjon included
  const [showModalCashMovement, setShowModalCashMovement] = useState(false);
  const updateShowModalCashMovement = (state) => {
    setShowModalCashMovement(state);
  };

  // Fault reports raised from the till
  const [showModalErrorTicket, setShowModalErrorTicket] = useState(false);
  const updateShowModalErrorTicket = (state) => {
    setShowModalErrorTicket(state);
  };

  // Mini safe and the money bags in the safe
  const [showModalSafe, setShowModalSafe] = useState(false);
  const updateShowModalSafe = (state) => {
    setShowModalSafe(state);
  };

  const [showModalSellPapirKingo, setShowModalSellPapirKingo] = useState(false);
  const updateShowModalSellPapirKingo = (state) => {
    setShowModalSellPapirKingo(state);
  };

  const [showModalSellPapirXtipp, setShowModalSellPapirXtipp] = useState(false);
  const updateShowModalSellPapirXtipp = (state) => {
    setShowModalSellPapirXtipp(state);
  };

  const [showModalSellPapir, setShowModalSellPapir] = useState(false);
  const updateShowModalSellPapir = (state) => {
    setShowModalSellPapir(state);
  };

  const [lastDataBingoTicket, setLastDataBingoTicket] = useState(false);
  const updateLastDataBingoTicket = (state) => {
    setLastDataBingoTicket(state);
  };

  const [showModalUnlockUser, setShowModalUnlockUser] = useState(false);
  const updateShowModalUnlockUser = (state) => {
    setShowModalUnlockUser(state);
  };

  const [lockUserInfo, setLockUserInfo] = useState(false);
  const updateLockUserInfo = (state) => {
    setLockUserInfo(state);
  };

  const [showModalUserExpired, setShowModalUserExpired] = useState(false);
  const updateShowModalUserExpired = (state) => {
    setShowModalUserExpired(state);
  };

  const [isEditingAfterExpiry, setIsEditingAfterExpiry] = useState(false);
  const updateIsEditingAfterExpiry = (state) => {
    setIsEditingAfterExpiry(state);
  };

  const [showModalMysteryWinners, setShowModalMysteryWinners] = useState(false);
  const updateShowModalMysteryWinners = (state) => {
    setShowModalMysteryWinners(state);
  };

  const [infoModalMysteryWinners, setInfoModalMysteryWinners] = useState(false);
  const updateInfoModalMysteryWinners = (state) => {
    setInfoModalMysteryWinners(state);
  };

  const [showModalTerminals, setShowModalTerminals] = useState(false);
  const updateShowModalTerminals = (state) => {
    setShowModalTerminals(state);
  };

  const [terminals, setTerminals] = useState(false);
  const updateTerminals = (value) => {
    setTerminals(value);
  };

  const [showModalPaperOut, setShowModalPaperOut] = useState(null);
  const updateShowModalPaperOut = (state) => {
    setShowModalPaperOut(state);
  };

  const [closeTime, setCloseTime] = useState(false);
  const updateCloseTime = (value) => {
    setCloseTime(value);
  };

  // Kiosk related states

  const [kiosk, setKiosk] = useState(false);
  const updateKiosk = (state) => {
    setKiosk(state);
  };

  const [isKioskGuest, setIsKioskGuest] = useState(false);
  const updateIsKioskGuest = (state) => {
    setIsKioskGuest(state);
  };

  const [transactionsKiosk, setTransactionsKiosk] = useState([]);

  const updateTransactionsKiosk = (newTransaction) => {
    setTransactionsKiosk([...transactionsKiosk, newTransaction]);
  };
  const updateTransactionsKioskArray = (newTransaction) => {
    setTransactionsKiosk([...transactionsKiosk, ...newTransaction]);
  };
  const deleteTransactionsKiosk = (newTransaction) => {
    setTransactionsKiosk(newTransaction);
  };
  const resetTransactionsKiosk = () => {
    setTransactions([]);
  };

  const [isSelfServiceKiosk, setIsSelfServiceKiosk] = useState(false);
  const updateIsSelfServiceKiosk = (state) => {
    setIsSelfServiceKiosk(state);
  };

  const [showModalWrongKioskUser, setShowModalWrongKioskUser] = useState(false);
  const updateShowModalWrongKioskUser = (state) => {
    setShowModalWrongKioskUser(state);
  };

  const [showModalSellKiosk, setShowModalSellKiosk] = useState(false);
  const updateShowModalSellKiosk = (state) => {
    setShowModalSellKiosk(state);
  };

  const logoutKiosk = () => {
    setTransactionsKiosk([]);
    setSession(false);
    setIsLogin(false);
    setPrintReceiptKiosk(false);
    setIsDataBingoBlockedInKiosk(false);
    setTicketSelectedKioskCH(false);
    setTicketSelectedKioskOK(false);
    setTicketParamsSelectedKioskOK(false);
    setTicketSelectedKioskWG(false);
    setTicketInfoKiosk(false);
  };

  const [showModalConfirmLogout, setShowModalConfirmLogout] = useState(false);
  const updateShowModalConfirmLogout = (state) => {
    setShowModalConfirmLogout(state);
  };

  const [showModalPaymentKiosk, setShowModalPaymentKiosk] = useState(false);
  const updateShowModalPaymentKiosk = (state) => {
    setShowModalPaymentKiosk(state);
  };

  const [printReceiptKiosk, setPrintReceiptKiosk] = useState(false);
  const updatePrintReceiptKiosk = (state) => {
    setPrintReceiptKiosk(state);
  };

  const [isDataBingoBlockedInKiosk, setIsDataBingoBlockedInKiosk] =
    useState(false);
  const updateIsDataBingoBlockedInKiosk = (state) => {
    setIsDataBingoBlockedInKiosk(state);
  };

  const [showModalBlockedToBuyDataBingo, setShowModalBlockedToBuyDataBingo] =
    useState(false);
  const updateShowModalBlockedToBuyDataBingo = (state) => {
    setShowModalBlockedToBuyDataBingo(state);
  };

  const [showModalLimitSurpassedKiosk, setShowModalLimitSurpassedKiosk] =
    useState(false);
  const updateShowModalLimitSurpassedKiosk = (state) => {
    setShowModalLimitSurpassedKiosk(state);
  };

  const [ticketSelectedKioskCH, setTicketSelectedKioskCH] = useState(false);
  const updateTicketSelectedKioskCH = (state) => {
    setTicketSelectedKioskCH(state);
  };

  const [ticketSelectedKioskOK, setTicketSelectedKioskOK] = useState(false);
  const updateTicketSelectedKioskOK = (state) => {
    setTicketSelectedKioskOK(state);
  };

  const [ticketParamsSelectedKioskOK, setTicketParamsSelectedKioskOK] =
    useState(false);
  const updateTicketParamsSelectedKioskOK = (state) => {
    setTicketParamsSelectedKioskOK(state);
  };

  const [ticketSelectedKioskWG, setTicketSelectedKioskWG] = useState(false);
  const updateTicketSelectedKioskWG = (state) => {
    setTicketSelectedKioskWG(state);
  };

  const [showModalTicketInfoKiosk, setShowModalTicketInfoKiosk] =
    useState(false);
  const updateShowModalTicketInfoKiosk = (state) => {
    setShowModalTicketInfoKiosk(state);
  };

  const [ticketInfoKiosk, setTicketInfoKiosk] = useState(false);
  const updateTicketInfoKiosk = (state) => {
    setTicketInfoKiosk(state);
  };

  const [kioskPaymentCardEnabled, setKioskPaymentCardEnabled] = useState(false);
  const updateKioskPaymentCardEnabled = (state) => {
    setKioskPaymentCardEnabled(state);
  };

  const [kioskPaymentAccountEnabled, setKioskPaymentAccountEnabled] =
    useState(false);
  const updateKioskPaymentAccountEnabled = (state) => {
    setKioskPaymentAccountEnabled(state);
  };

  const [isLoginRefill, setIsLoginRefill] = useState(false);
  const updateIsLoginRefill = (state) => {
    setIsLoginRefill(state);
  };

  const [showModalConfirmPinKiosk, setShowModalConfirmPinKiosk] =
    useState(false);
  const updateShowModalConfirmPinKiosk = (state) => {
    setShowModalConfirmPinKiosk(state);
  };

  const [showModalPaperOutKiosk, setShowModalPaperOutKiosk] = useState(null);
  const updateShowModalPaperOutKiosk = (state) => {
    setShowModalPaperOutKiosk(state);
  };

  const [
    infoAutoOpenAfterCloseZeroTicket,
    setInfoAutoOpenAfterCloseZeroTicket,
  ] = useState(false);
  const updateInfoAutoOpenAfterCloseZeroTicket = (state) => {
    setInfoAutoOpenAfterCloseZeroTicket(state);
  };

  const [printerIP, setPrinterIP] = useState(false);
  const updatePrinterIP = (value) => {
    setPrinterIP(value);
  };

  //* CRASH / REFRESH RECOVERY (cashier only): the client and the sale in progress
  // Read once on mount, before anything can overwrite it
  const [pendingSnapshot, setPendingSnapshot] = useState(() => readSnapshot());

  useEffect(() => {
    if (isSelfServiceKiosk || !isLogin) {
      return;
    }

    const hasSale = Boolean(userLogin) || transactions.length > 0;

    if (!hasSale) {
      // Never wipe a snapshot that is still waiting for the operator's answer
      if (!pendingSnapshot) {
        clearSnapshot();
      }
      return;
    }

    writeSnapshot({
      hall: hall,
      operator: operator,
      user: {
        currentUser,
        currentUserID,
        userLogin,
        userInfo,
        isFullUser,
        isAnonUser,
        isHybridUser,
        isFastUserLogin,
        userChildren,
        userSiblings,
        userParent,
        parentInfo,
        userLimits,
        maxAllowed,
      },
      sale: {
        transactions,
        total,
        payCash,
        payCard,
        paySpillerkonto,
        change,
        withdraw,
        isCard,
        isCash,
        ticketsCH,
        ticketsEBS,
        currentTicketEBS,
        ticketsWG,
        currentTicketWG,
        ticketsOK,
        currentTicketOK,
        ticketsTempOK,
        ticketsTempWG,
        currentTicketTempOK,
      },
    });
  }, [
    isSelfServiceKiosk,
    isLogin,
    pendingSnapshot,
    hall,
    operator,
    currentUser,
    currentUserID,
    userLogin,
    userInfo,
    isFullUser,
    isAnonUser,
    isHybridUser,
    isFastUserLogin,
    userChildren,
    userSiblings,
    userParent,
    parentInfo,
    userLimits,
    maxAllowed,
    transactions,
    total,
    payCash,
    payCard,
    paySpillerkonto,
    change,
    withdraw,
    isCard,
    isCash,
    ticketsCH,
    ticketsEBS,
    currentTicketEBS,
    ticketsWG,
    currentTicketWG,
    ticketsOK,
    currentTicketOK,
    ticketsTempOK,
    ticketsTempWG,
    currentTicketTempOK,
  ]);

  const restorePendingSnapshot = () => {
    if (!pendingSnapshot) {
      return;
    }

    const user = pendingSnapshot.user;
    const sale = pendingSnapshot.sale;

    setCurrentUser(user.currentUser || '');
    setCurrentUserID(user.currentUserID || '');
    setUserLogin(Boolean(user.userLogin));
    setUserInfo(user.userInfo || {});
    setIsFullUser(Boolean(user.isFullUser));
    setIsAnonUser(Boolean(user.isAnonUser));
    setIsHybridUser(Boolean(user.isHybridUser));
    setIsFastUserLogin(Boolean(user.isFastUserLogin));
    setUserChildren(user.userChildren || []);
    setUserSiblings(user.userSiblings || []);
    setUserParent(user.userParent || false);
    setParentInfo(user.parentInfo || false);
    setUserLimits(user.userLimits || {});
    setMaxAllowed(user.maxAllowed || 0);

    setTransactions(sale.transactions || []);
    setTotal(sale.total || 0);
    setPayCash(sale.payCash || 0);
    setPayCard(sale.payCard || 0);
    setPaySpillerkonto(sale.paySpillerkonto || 0);
    setChange(sale.change || 0);
    setWithdraw(sale.withdraw || 0);
    setIsCard(Boolean(sale.isCard));
    setIsCash(Boolean(sale.isCash));
    setTicketsCH(sale.ticketsCH || []);
    setTicketsEBS(sale.ticketsEBS || []);
    setCurrentTicketEBS(sale.currentTicketEBS || false);
    setTicketsWG(sale.ticketsWG || []);
    setCurrentTicketWG(sale.currentTicketWG || false);
    setTicketsOK(sale.ticketsOK || []);
    setCurrentTicketOK(sale.currentTicketOK || false);
    setTicketsTempOK(sale.ticketsTempOK || []);
    setTicketsTempWG(sale.ticketsTempWG || []);
    setCurrentTicketTempOK(sale.currentTicketTempOK || false);

    setPendingSnapshot(null);
  };

  const discardPendingSnapshot = () => {
    clearSnapshot();
    setPendingSnapshot(null);
  };

  return (
    <AppContext.Provider
      value={{
        closeTime,
        updateCloseTime,
        printerIP,
        updatePrinterIP,
        infoAutoOpenAfterCloseZeroTicket,
        updateInfoAutoOpenAfterCloseZeroTicket,
        terminals,
        updateTerminals,
        showModalTerminals,
        updateShowModalTerminals,
        showModalPaperOut,
        updateShowModalPaperOut,
        showModalPaperOutKiosk,
        updateShowModalPaperOutKiosk,
        showModalConfirmPinKiosk,
        updateShowModalConfirmPinKiosk,
        isLoginRefill,
        updateIsLoginRefill,
        kioskPaymentAccountEnabled,
        updateKioskPaymentAccountEnabled,
        kioskPaymentCardEnabled,
        updateKioskPaymentCardEnabled,
        ticketInfoKiosk,
        updateTicketInfoKiosk,
        showModalTicketInfoKiosk,
        updateShowModalTicketInfoKiosk,
        ticketSelectedKioskWG,
        updateTicketSelectedKioskWG,
        ticketSelectedKioskOK,
        updateTicketSelectedKioskOK,
        ticketParamsSelectedKioskOK,
        updateTicketParamsSelectedKioskOK,
        ticketSelectedKioskCH,
        updateTicketSelectedKioskCH,
        showModalLimitSurpassedKiosk,
        updateShowModalLimitSurpassedKiosk,
        showModalBlockedToBuyDataBingo,
        updateShowModalBlockedToBuyDataBingo,
        isDataBingoBlockedInKiosk,
        updateIsDataBingoBlockedInKiosk,
        printReceiptKiosk,
        updatePrintReceiptKiosk,
        showModalPaymentKiosk,
        updateShowModalPaymentKiosk,
        showModalConfirmLogout,
        updateShowModalConfirmLogout,
        transactionsKiosk,
        updateTransactionsKiosk,
        updateTransactionsKioskArray,
        deleteTransactionsKiosk,
        resetTransactionsKiosk,
        logoutKiosk,
        infoModalMysteryWinners,
        updateInfoModalMysteryWinners,
        showModalMysteryWinners,
        updateShowModalMysteryWinners,
        showModalUserExpired,
        updateShowModalUserExpired,
        isEditingAfterExpiry,
        updateIsEditingAfterExpiry,
        showModalUnlockUser,
        updateShowModalUnlockUser,
        lockUserInfo,
        updateLockUserInfo,
        lastDataBingoTicket,
        updateLastDataBingoTicket,
        showModalSellPapirXtipp,
        updateShowModalSellPapirXtipp,
        showModalSellPapirKingo,
        updateShowModalSellPapirKingo,
        showModalSellPapir,
        updateShowModalSellPapir,
        showModalSellKiosk,
        updateShowModalSellKiosk,
        showModalWrongKioskUser,
        updateShowModalWrongKioskUser,
        isSelfServiceKiosk,
        updateIsSelfServiceKiosk,
        isKioskGuest,
        updateIsKioskGuest,
        papirPrize,
        updatePapirPrize,
        showModalRefund,
        showModalCashMovement,
        updateShowModalCashMovement,
        showModalErrorTicket,
        updateShowModalErrorTicket,
        showModalSafe,
        updateShowModalSafe,
        updateShowModalRefund,
        maximumAnonPrizeAllowed,
        updateMaximumAnonPrizeAllowed,
        kiosk,
        updateKiosk,
        papirScannedInfo,
        updatePapirScannedInfo,
        isPapirEnabled,
        updateIsPapirEnabled,
        isPapirKingoEnabled,
        updateIsPapirKingoEnabled,
        isPapirXtippEnabled,
        updateIsPapirXtippEnabled,
        isFlaxEnabled,
        updateIsFlaxEnabled,
        showModalPapirTicketNotSold,
        updateShowModalPapirTicketNotSold,
        showModalPapirTicketAlreadySold,
        updateShowModalPapirTicketAlreadySold,
        showModalPapirTicketNotValid,
        updateShowModalPapirTicketNotValid,
        showModalPapirGameNotFinished,
        updateShowModalPapirGameNotFinished,
        showModalPapirGameFinishedWithPrize,
        updateShowModalPapirGameFinishedWithPrize,
        showModalPapirGameFinishedWithoutPrize,
        updateShowModalPapirGameFinishedWithoutPrize,
        showModalPapirCheckCard,
        updateShowModalPapirCheckCard,
        papirCardInfo,
        updatePapirCardInfo,
        showModalPapirGameBatchResult,
        updateShowModalPapirGameBatchResult,

        isAdmin,
        updateIsAdmin,
        disableSellForUser,
        updateDisableSellForUser,

        isEnabledBankID,
        updateIsEnabledBankID,
        isIdentityConfirmed,
        updateIsIdentityConfirmed,
        bingoID,
        updateBingoID,
        isLoadingScreen,
        updateIsLoadingScreen,
        isOKBingoEnabled,
        updateIsOKBingoEnabled,
        isWGEnabled,
        updateIsWGEnabled,
        OKBingoID,
        updateOKBingoID,
        WGBingoID,
        updateWGBingoID,
        enviroment,
        updateEnviroment,
        isWaitingForUser,
        updateIsWaitingForUser,
        focusOnMainScreen,
        updateFocusOnMainScreen,
        isLogin,
        updateLogin,
        modifyLogin,
        providerIndex,
        updateProviderIndex,
        transactions,
        updateTransactions,
        updateTransactionsArray,
        deleteTransactions,
        resetTransactions,
        operator,
        modifyOperator,
        operatorFull,
        modifyOperatorFull,
        operatorInfo,
        modifyOperatorInfo,
        hall,
        modifyHall,
        kioskHall,
        modifyKioskHall,
        showModalEmptyHall,
        updateShowModalEmptyHall,
        isBlocking,
        BlockingScreen,
        userLogin,
        updateUserLogin,
        currentUser,
        updateCurrentUser,
        currentUserID,
        updateCurrentUserID,
        userInfo,
        updateUserInfo,
        isFullUser,
        updateIsFullUser,
        isAnonUser,
        updateIsAnonUser,
        isHybridUser,
        updateIsHybridUser,
        isFastUserLogin,
        updateIsFastUserLogin,
        session,
        updateSession,
        isBlockProviderOK,
        isBlockProviderWG,
        isBlockProviderNT,
        isBlockProviderEBS,
        modifyProvider,
        isMultiplier,
        isMultiplier2,
        isMultiplier3,
        isMultiplier4,
        isMultiplier5,
        isMultiplier6,
        isMultiplier7,
        isMultiplier8,
        isMultiplier9,
        isMultiplier10,
        updateIsMultiplier,
        updateIsMultiplier2,
        updateIsMultiplier3,
        updateIsMultiplier4,
        updateIsMultiplier5,
        updateIsMultiplier6,
        updateIsMultiplier7,
        updateIsMultiplier8,
        updateIsMultiplier9,
        updateIsMultiplier10,
        isShortcut,
        isShortcut10,
        isShortcut20,
        isShortcut30,
        isShortcut50,
        isShortcut100,
        isShortcut200,
        updateIsShortcut,
        updateIsShortcut10,
        updateIsShortcut20,
        updateIsShortcut30,
        updateIsShortcut50,
        updateIsShortcut100,
        updateIsShortcut200,
        isPaymentOpen,
        updateIsPaymentOpen,
        paymentType,
        updatePaymentType,
        total,
        payCard,
        payCash,
        payCardTemp,
        payCashTemp,
        paySpillerkonto,
        paySpillerkontoTemp,
        change,
        withdraw,
        updateTotal,
        updatePayCard,
        updatePayCash,
        updatePayCardTemp,
        updatePayCashTemp,
        updatePaySpillerkonto,
        updatePaySpillerkontoTemp,
        updateChange,
        updateWithdraw,
        isSellerOpen,
        updateIsSellerOpen,
        isPapirOpen,
        updateIsPapirOpen,
        isPapirKingoOpen,
        updateIsPapirKingoOpen,
        isFlaxOpen,
        updateIsFlaxOpen,
        isPapirXtippOpen,
        updateIsPapirXtippOpen,
        isOcrOpen,
        updateIsOcrOpen,
        vendorInfo,
        updateVendorInfo,
        sellType,
        updateSellType,
        isCard,
        isCash,
        updateIsCard,
        updateIsCash,
        autoSearch,
        searchByPin,
        searchByID,
        searchByUsername,
        searchByPhonenumber,
        searchByFirstname,
        searchByLastname,
        searchBySSNID,
        updateAutoSearch,
        updateSearchByPin,
        updateSearchByID,
        updateSearchByUsername,
        updateSearchByPhonenumber,
        updateSearchByFirstname,
        updateSearchByLastname,
        updateSearchBySSNID,
        print,
        updatePrint,
        printer,
        updatePrinter,
        showCard,
        updateShowCard,
        showSpillerkonto,
        updateShowSpillerkonto,
        showSpillerkontoPayment,
        updateShowSpillerkontoPayment,
        ticketsCH,
        addTicketsCH,
        addMultipleTicketsCH,
        removeTicketsCH,
        resetTicketsCH,
        cardID,
        updateCardID,
        userChildren,
        updateUserChildren,
        userParent,
        updateUserParent,
        userSiblings,
        updateUserSiblings,
        logoutUser,
        parentInfo,
        updateParentInfo,
        showSpecialGames,
        updateShowSpecialGames,
        isTerminalBusy,
        updateIsTerminalBusy,
        isCashoutPending,
        updateIsCashoutPending,
        refreshUser,
        updateRefreshUser,
        gameID,
        updateGameID,
        isFullUserRegistration,
        updateIsFullUserRegistration,
        isFullUserEditing,
        updateIsFullUserEditing,
        isHybridUserRegistration,
        updateIsHybridUserRegistration,
        isHybridUserEditing,
        updateIsHybridUserEditing,
        isAnonUserRegistration,
        updateIsAnonUserRegistration,
        isReportEnabled,
        updateIsReportEnabled,
        isShiftOpen,
        updateIsShiftOpen,
        isFirstShiftOfTheDay,
        updateIsFirstShiftOfTheDay,
        previousShiftClose,
        updatePreviousShiftClose,
        closeShiftNumbers,
        updateCloseShiftNumbers,
        ticketPictureOK,
        updateTicketPictureOK,
        ticketPictureWG,
        updateTicketPictureWG,
        ticketPictureNT,
        updateTicketPictureNT,
        showSignature,
        updateShowSignature,
        isSigned,
        updateIsSigned,
        openSessionTerminal,
        updateOpenSessionTerminal,
        showModalStartShift,
        updateShowModalStartShift,
        showModalEndShift,
        updateShowModalEndShift,
        isDailyReportCompleted,
        updateIsDailyReportCompleted,
        isCardReportCompleted,
        updateIsCardReportCompleted,
        isWGReportCompleted,
        updateIsWGReportCompleted,
        addCancelTransaction,
        showUserInfo,
        updateShowUserInfo,
        showUserInfoOK,
        updateShowUserInfoOK,
        showUserInfoWG,
        updateShowUserInfoWG,
        isWaitingForExternalProviderInfo,
        updateIsWaitingForExternalProviderInfo,
        receiptToPrint,
        updateReceiptToPrint,
        isSingleTransaction,
        updateIsSingleTransaction,
        allUsers,
        updateAllUsers,
        showKiosk,
        updateShowKiosk,
        showModalUserFound,
        updateShowModalUserFound,
        showModalUserNotFound,
        updateShowModalUserNotFound,
        userToSearch,
        updateUserToSearch,
        usersResults,
        updateUserResults,
        ticketsEBS,
        updateTicketsEBS,
        currentTicketEBS,
        updateCurrentTicketEBS,
        ticketsWG,
        updateTicketsWG,
        currentTicketWG,
        updateCurrentTicketWG,
        ticketsTempWG,
        updateTicketsTempWG,
        ticketsOK,
        updateTicketsOKWithNewSaldo,
        updateTicketsOK,
        ticketsTempOK,
        updateTicketsTempOK,
        currentTicketOK,
        updateCurrentTicketOK,
        currentTicketTempOK,
        updateCurrentTicketTempOK,
        favUsers,
        updateFavUsers,
        showModalEditUserLimits,
        updateShowModalEditUserLimits,
        showCardToCash,
        updateShowCardToCash,
        showIsLimitSurpassed,
        updateShowIsLimitSurpassed,
        isLimitSurpassed,
        updateIsLimitSurpassed,
        isDailyLimitSurpassed,
        updateIsDailyLimitSurpassed,
        isMonthlyLimitSurpassed,
        updateIsMonthlyLimitSurpassed,
        isVerificationNeeded,
        updateIsVerificationNeeded,
        showModalIsVerificationNeeded,
        updateShowModalIsVerificationNeeded,
        userLimits,
        updateUserLimits,
        showIsLimitSurpassedTransaction,
        updateShowIsLimitSurpassedTransaction,
        maxAllowed,
        updateMaxAllowed,
        showModalDifferentParent,
        updateShowModalDifferentParent,
        showModalDifferentParentOK,
        updateShowModalDifferentParentOK,
        showModalDifferentParentWG,
        updateShowModalDifferentParentWG,
        adoptedTicket,
        updateAdoptedTicket,
        showUserInfoSibling,
        updateShowUserInfoSibling,
        showUserInfoSiblingOK,
        updateShowUserInfoSiblingOK,
        scannedTicket,
        updateScannedTicket,
        isPictureVerificationNeeded,
        updateIsPictureVerificationNeeded,
        showModalPictureVerificationWarning,
        updateShowModalPictureVerificationWarning,
        showModalPictureVerification,
        updateShowModalPictureVerification,
        userImageInfo,
        updateUserImageInfo,
        showModalProfileImage,
        updateShowModalProfileImage,
        showModalPictureVerificationPreRegister,
        updateShowModalPictureVerificationPreRegister,
        imageVerificationTemp,
        updateImageVerificationTemp,
        imageVerificationSignatureTemp,
        updateImageVerificationSignatureTemp,
        isDisconnected,
        updateIsDisconnected,
        isReconnected,
        updateIsReconnected,
        signatureInfo,
        updateSignatureInfo,
        showModalSignatureStep1,
        updateShowModalSignatureStep1,

        showModalSignatureStep2,
        updateShowModalSignatureStep2,
        specialGameInfo,
        updateSpecialGameInfo,
        signatureTemp,
        updateSignatureTemp,
        isNeedSignature,
        updateIsNeedSignature,
        isNeedConfirmation,
        updateIsNeedConfirmation,
        reactivateNeedSignatureModal,
        updateReactivateNeedSignatureModal,
        isWaitingForCancelOK,
        updateIsWaitingForCancelOK,
        isNTEnabled,
        updateIsNTEnabled,
        isKioskEnabled,
        updateIsKioskEnabled,
        isSignaturesStored,
        updateIsSignaturesStored,
        showModalSignaturePostponed,
        updateShowModalSignaturePostponed,
        isPostponedID,
        updateIsPostponedID,
        showWaitingForScan,
        updateShowWaitingForScan,
        showPreRegisterForm,
        updateShowPreRegisterForm,
        showPreRegisterHybridForm,
        updateShowPreRegisterHybridForm,
        showBankIDForm,
        updateShowBankIDForm,
        showModalPEP,
        updateShowModalPEP,
        showModalWaitingForPEP,
        updateShowModalWaitingForPEP,
        showModalWaitingForCommunication,
        updateShowModalWaitingForCommunication,
        showModalWaitingForTerms,
        updateShowModalWaitingForTerms,
        showModalWaitingForNewPincode,
        updateShowModalWaitingForNewPincode,
        userRegisterCommunication,
        updateUserRegisterCommunication,
        userRegisterTerms,
        updateUserRegisterTerms,
        userRegisterPEP,
        updateUserRegisterPEP,
        userRegisterOptionsPEP,
        updateUserRegisterOptionsPEP,
        showModalHybridMustBeUser,
        updateShowModalHybridMustBeUser,
        showModalUserNeedManualCheck,
        updateShowModalUserNeedManualCheck,
        showWaitingForScanNfc,
        updateShowWaitingForScanNfc,
        showModalUserIsBanned,
        updateShowModalUserIsBanned,
        showModalBanUser,
        updateShowModalBanUser,
        showModalWaitingForRisky,
        updateShowModalWaitingForRisky,
        showModalConfirmIdentity,
        updateShowModalConfirmIdentity,
        isLoginFromNfc,
        updateIsLoginFromNfc,
        isDataBingoBlocked,
        updateIsDataBingoBlocked,
        isMainGameBlocked,
        updateIsMainGameBlocked,
        showModalSellBlocked,
        updateShowModalSellBlocked,
        userInfoBlocked,
        updateUserInfoBlocked,
        isSystemLockEnabled,
        showModalUserLimitStatus,
        updateShowModalUserLimitStatus,
        updateIsSystemLockEnabled,
        showModalForbiddenUserAccess,
        updateShowModalForbiddenUserAccess,
        showModalUserHasPasswordBlock,
        updateShowModalUserHasPasswordBlock,
        pendingSnapshot,
        restorePendingSnapshot,
        discardPendingSnapshot,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
